import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import { Wrapper as QueryClientProvider } from "../helpers/queryClient";

const AutoAssignmentForm = lazy(
  () => import("../components/administration/channels/AutoAssignmentForm"),
);

// Connects to data-controller="auto-assignment-form"
// Intended be used on a div container
export default class extends Controller {
  connect() {
    this.originalType = this.element.type;
    this.element.type = "hidden";

    const container = document.createElement("div");
    this.element.insertAdjacentElement("afterend", container);
    this.root = createRoot(container);
    this.root.render(
      <QueryClientProvider>
        <Suspense fallback={null}>
          <AutoAssignmentForm />
        </Suspense>
      </QueryClientProvider>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
      this.element.type = this.originalType;
    }
  }
}
